import React from 'react';
import './radio-button-group.scss';

const RadioButtonGroup = ({ selectedValue, onChange, options }) => {
    return (
      <div className="radio-button-group">
        {options.map((option) => {
          const isChecked = selectedValue === option.value;
          return (
            <label
              key={option.value}
              className={`radio-button${isChecked ? ' radio-button--checked' : ''}`}
            >
              <input
                type="radio"
                className="radio-button__input"
                name="radio-group"
                value={option.value}
                checked={isChecked}
                onChange={(e) => {
                    console.log('Radio clicked:', e.target.value); 
                    onChange(e); 
                  }}
                  
              />
              <div className="radio-button__tick"></div>
              <div className="radio-button__label">{option.label}</div>
            </label>
          );
        })}
      </div>
    );
  };
  
export default RadioButtonGroup;
